import React from 'react';
import LegalPageTemplate from './LegalPageTemplate';

const TargetMarket = () => {
  return (
    <LegalPageTemplate title="Target Market Determination">
      <div className="prose max-w-none space-y-6">
        <div className="text-center mb-8 p-6 bg-secondary/5 rounded-2xl border-l-4 border-secondary">
          <p className="font-bold text-primary">STRAWBERRY LOANS PTY LTD REPRESENTED BY AIRCASH FINANCE PTY LTD</p>
          <p className="font-bold text-primary">(AUTHORISED CREDIT REPRESENTATIVE.)</p>
          <p className="font-bold text-primary">AUSTRALIAN CREDIT LICENCE 519253</p>
        </div>

        <h1 className="text-2xl font-bold text-primary mb-4">TARGET MARKET DETERMINATION (TMD)</h1>
        <h2 className="text-xl font-semibold text-gray-700 mb-6">Medium Amount Credit Contracts – Personal Loans</h2>
        
        <p>Prepared and published in acknowledgement of the requirements imposed on "issuer" companies involved in the provision of credit under the Treasury Laws Amendment (Design and Distribution Obligations and Product Intervention Powers) Act 2019.</p>
        
        <p>The product is a Medium Amount Credit Contract (as defined in Section 204 and prescribed in Sections 32A and 32B of the National Credit Code) – a consumer loan product regulated by the National Consumer Credit Protection Act 2009.</p>

        <div>
          <h3 className="text-lg font-semibold text-primary mb-4 mt-8">Key attributes of the product:</h3>
          <ul className="list-disc pl-6">
            <li>Loan amounts from $2,001 to $5,000.</li>
            <li>Loan terms from 6 to 24 months.</li>
            <li>Interest rates (annual cost rates) up to and including 47.6158% per annum.</li>
            <li>Establishment fee - $400.</li>
            <li>Secured and unsecured loans, with security, when required, taken over the consumer's motor vehicle or other unencumbered asset.</li>
            <li>Fixed interest rate.</li>
            <li>Equal repayments - weekly, fortnightly or monthly.</li>
            <li>No termination or early payout fee.</li>
            <li>No balloon payment.</li>
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-semibold text-primary mb-4 mt-8">Who are the target consumer/s, target market?</h3>
          <p>Consumers who:</p>
          <ul className="list-disc pl-6">
            <li>are individuals between 18-70 years of age;</li>
            <li>with a proven source of income;</li>
            <li>with an established credit history;</li>
            <li>with stable residence;</li>
            <li>have security to offer (e.g. unencumbered motor vehicle registered in their name);</li>
            <li>meet lending criteria concerning affordability of the loan;</li>
            {/* <li>satisfy National Consumer Credit Protection Act responsible lending requirements as to availability of financial information.</li> */}
          </ul>
        </div>

{/*         <div>
          <h3 className="text-lg font-semibold text-primary mb-4 mt-8">Consumers or classes of consumers that are excluded from the target market</h3>
          <p>Consumers who are:</p>
          <ul className="list-disc pl-6">
            <li>currently bankrupt;</li>
            <li>currently in a debt agreement;</li>
            <li>unlikely to have a stable and adequate source of income during the loan term;</li>
            <li>under the age of 18 or over 70;</li>
            <li>not either an Australian citizen, or permanent resident;</li>
            <li>are unable to provide financial information required for verification during the application process; and</li>
            <li>are unable to understand the nature of a credit contract.</li>
          </ul>
        </div> */}

        {/* <div>
          <h3 className="text-lg font-semibold text-primary mb-4 mt-8">Target consumers' likely objectives, financial situation and needs</h3>
          
          <h4 className="font-semibold text-primary mt-6 mb-3">Consumer's likely objectives</h4>
          <ul className="list-disc pl-6">
            <li>easy online application;</li>
            <li>ease of dealing with their source of loan finance;</li>
            <li>quick responses;</li>
            <li>fast turnaround times;</li>
            <li>fixed interest rates;</li>
            <li>relatively short loan terms;</li>
            <li>equal repayments to fit within their budget;</li>
            <li>flexible payment frequency to suit their budget;</li>
            <li>ability to understand the credit product;</li>
            <li>access to adequate information;</li>
            <li>avoidance of unnecessary financial risk;</li>
            <li>satisfaction of risk profile; and</li>
            <li>ability to derive benefit from the loan product.</li>
          </ul>

          <h4 className="font-semibold text-primary mt-6 mb-3">Consumers likely financial situation</h4>
          <ul className="list-disc pl-6">
            <li>stable income;</li>
            <li>not unemployed or underemployed;</li>
            <li>not retired;</li>
            <li>with an established credit history;</li>
            <li>manageable other debt;</li>
            <li>adequately managed and controlled expenditure on alcohol, Buy Now/Pay Later transactions and gambling;</li>
            <li>recent bank statements demonstrate financial management without experiencing substantial hardship;</li>
            <li>income amount in excess of other existing and projected commitments and proposed loan repayments; and</li>
            <li>no current indication of adverse financial issues arising and negatively impacting on the ability to repay loans over the anticipated term of the new loan.</li>
          </ul>

          <h4 className="font-semibold text-primary mt-6 mb-3">Consumer's likely needs</h4>
          <p>Seeking a loan of between $2,001 and $5,000 (plus establishment fee of $400 if applicable) to purchase an asset or other goods and services, or to consolidate other debts/bills, pay for car repairs, holidays, weddings, funerals, education, renovations and spread repayments over a relatively short term.</p>
        </div>
 */}
{/*         <div>
          <h3 className="text-lg font-semibold text-primary mb-4 mt-8">Why the product is likely to be consistent with the likely objectives, financial situation and needs of consumers in the target market?</h3>
          <p>The product is a simple credit product, which is the foundation for the likely effect of the company's distribution conditions.</p>
          <p>Product features, such as loan amounts, fixed interest rates, short to medium loan terms, equal repayments and choice of payment frequency are likely to be consistent with the likely objectives, financial situation and needs of consumers in the target market. Additionally, the service provided by Strawberry Loans, including easy online application, quick response and turnaround times, is also likely to meet the likely objectives, financial situation and needs of consumers in the target market.</p>
          <p>The products have been the subject of robust testing under the Commonwealth credit regulatory regime, are fundamental to the Australian market place in that they do not have any unique features that are unfamiliar to the consumers in the target markets, most of whom have relevant borrowing experience.</p>
          <p>Company loan performance data and feedback from distributors, engaged from time to time, does not reveal any systemic inconsistencies between the design of the credit product and the target market's requirements, financial circumstances and needs.</p>
          <p>Industry sector research commissioned by two industry sector representative organisations since 2008, and the industry sector's overall maintenance or growth in demand according to target market sub-set statistics, indicates continuing consistency between this product category and the target market's requirements, financial situation and needs.</p>
        </div> */}

{/*         <div>
          <h3 className="text-lg font-semibold text-primary mb-4 mt-8">Distribution method?</h3>
          <p>AirCash Finance Pty Ltd as the Authorised Credit Representative, via internet and telephone contact with applicant consumers.</p>
          <p>The distribution communications methodologies adopted, or that could be adopted, include websites, emails, Australia Post, social media and traditional advertising media such as print, radio and television from time to time.</p>
          <p>In accordance with the National Consumer Credit Protection Act 2009, Strawberry Loans, has the final decision on loan approval and supervises both in-house product distribution and brokers' efforts, with close attention to the Design and Distribution Obligations.</p>
        </div> */}

{/*         <div>
          <h3 className="text-lg font-semibold text-primary mb-4 mt-8">What conditions or restrictions are placed on distribution?</h3>
          <p>Conditions and/or restrictions include:</p>
          <ul className="list-disc pl-6">
            <li>No systematic ignoring or avoidance of this Target Market determination.</li>
            <li>Both company in-house representatives and authorised credit representatives' roles must adhere to company policy concerning loan suitability for consumers.</li>
            <li>Consumer decision fatigue, vulnerabilities and decision timing must be accommodated to avoid uninformed or unsuitable distribution to target market sub-sets.</li>
          </ul>
          <p>As with the outcome of reviews, the conditions or restrictions imposed are an attempt to eliminate, or at least minimise, the actual or potential degree of harm.</p>
        </div> */}

{/*         <div>
          <h3 className="text-lg font-semibold text-primary mb-4 mt-8">Why do those conditions mean the product is not likely to be distributed to consumers outside the target market?</h3>
          <p>These conditions are clearly communicated to all company representatives and distributors and are incorporated in employment and engagement agreements. They form part of the major terms and conditions of those agreements.</p>
          <p>Strawberry Loans has regular reviews of company credit policy, procedures and processes.</p>
        </div> */}

{/*         <div>
          <h3 className="text-lg font-semibold text-primary mb-4 mt-8">What triggers make it (the product or TMD) no longer appropriate?</h3>
          <p>These include, but may not be limited to, the following events and circumstances:</p>
          <ul className="list-disc pl-6">
            <li>Changes in legislation affecting the product or TMD.</li>
            <li>Reports from distributors and company personnel that a significant number of enquiries and applications are being received from potential consumers outside the defined target market.</li>
            <li>The companies' reviews, both ad hoc and scheduled, that reveal an inconsistency or mismatch between the product features and the target market's requirements, financial circumstances and/or needs. This causing, or likely to cause, identified material consumer financial or non-financial harm and being incapable of elimination or minimisation by subsequent TMD action.</li>
            <li>Economic changes, however caused, impacting on target market financial circumstances.</li>
            <li>Cultural changes and changes in traditions and fads, impacting on borrowing habits, preferences and purchasing and timing decisions using borrowed funds, all potentially leading to changes in target market requirements.</li>
            <li>Socio-economic changes impacting on perceived and actual target market needs.</li>
            <li>Significant dealings indicating a material inconsistency between the TMD and the delivered credit product and/or distributors and/or target market.</li>
          </ul>
        </div> */}

{/*         <div>
          <h3 className="text-lg font-semibold text-primary mb-4 mt-8">How often we want to review the TMD</h3>
          <p>The first review will be scheduled to regular reviews will be every 2 years.</p>
          <p>Where issues of concern in regard to inconsistency between the TMD and the credit product and/or target market arise, between these regular scheduled reviews, the companies' policy is to undertake a review and action the review's findings within 10 business days of the adverse information being brought to the attention of the company's TMD Manager, and with implementation of all recommendations.</p>
          <p>Where deemed appropriate and material, complaints, if any, will be brought to ASIC's attention by way of a "Significant Dealing Notification", within 10 days of any relevant review being completed.</p>
        </div> */}

{/*         <div>
          <h3 className="text-lg font-semibold text-primary mb-4 mt-8">What would trigger a review before the standard review?</h3>
          <ul className="list-disc pl-6">
            <li>Legislation changes affecting the product.</li>
            <li>Significant and unexpected increase in default rates, hardship rates or product complaint rates.</li>
            <li>A significant increase in applications from consumers outside the target market.</li>
            <li>Poor product performance or outcomes.</li>
            <li>Poor distribution delivery.</li>
            <li>Any other material inconsistency coming to the attention of the company, from any information source, in regard to the TMD and/or the product and/or the distribution and/or the target market.</li>
          </ul>
        </div> */}

{/*         <div>
          <h3 className="text-lg font-semibold text-primary mb-4 mt-8">How often do we want distributors to report complaints information to us?</h3>
          <p>Reporting from in-house representatives and third party distributors is scheduled monthly, but where numbers or type of complaint indicate a material significance, reporting will occur as soon as that significance emerges and is noted.</p>
          <p>In-house management and staff who are not representatives will also be encouraged to report at any time, where deemed relevant.</p>
          <p>In addition, the companies will welcome reports from other non-representatives and non-distributors at any time.</p>
        </div> */}

{/*         <div>
          <h3 className="text-lg font-semibold text-primary mb-4 mt-8">In what format and with what detail do we want them to report to us?</h3>
          <p>By email to the Responsible Manager in that Manager's role as TMD Manager.</p>
          <p>Details to be reported include:</p>
          <ul className="list-disc pl-6">
            <li>number of complaints received;</li>
            <li>time period over which the complaints were received;</li>
            <li>name of consumers;</li>
            <li>what the problem was, with particular attention to target market requirements, financial circumstances and needs;</li>
            <li>what the resolution was;</li>
            <li>the time to resolve it; and</li>
            <li>if there are any unresolved complaints.</li>
          </ul>
        </div> */}

{/*         <div>
          <h3 className="text-lg font-semibold text-primary mb-4 mt-8">Do we want them to report anything else to us?</h3>
          <p>Yes. In circumstances where there is no material level of complaint, or type of complaint, in their professional judgement a trend may be emerging, or the evolution of a more serious or material complaint could occur without attention to the causal issue at the time of the report.</p>
        </div> */}

{/*         <div>
          <h3 className="text-lg font-semibold text-primary mb-4 mt-8">What will we determine to be a significant dealing, i.e. where the product goes to consumers outside the target market or some other significant issue?</h3>
          <p>The companies will determine that there has been a significant dealing in the following circumstances (unless these are due to loan application fraud):</p>
          <ul className="list-disc pl-6">
            <li>where there are material levels of interest or demand from consumers outside the target market;</li>
            <li>if the product is distributed to consumers under 18 years of age;</li>
            <li>if the product is distributed to consumers who are not Australian citizens or permanent residents; and</li>
            <li>if the product is distributed in a manner that is otherwise materially inconsistent with company polices, as may be determined from time to time.</li>
          </ul>
        </div> */}
      </div>
    </LegalPageTemplate>
  );
};

export default TargetMarket;